import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { columnsPropType } from "../../types";
import styles from "./TableRow.module.css";

const TableRow = ({
  classNames,
  columns,
  index,
  row,
  style,
  snapshot,
  handlePopoverOpen,
  handlePopoverClose,
  onCopy,
}) => {
  const getFlexAlignment = (alignment) => {
    if (alignment === "center") return "center";
    if (alignment === "right") return "flex-end";
    return "flex-start";
  };

 

  const renderColumnCell = (col) => col.render && row ? (
      col.render(row, index + 1, {
        openEllipsisPopupForEventWithText: handlePopoverOpen,
        closeEllipsisPopup: handlePopoverClose,
        onCopy,
      })
    ) : (
      <div
        onDoubleClick={() => onCopy(row[col.field])}
        className={styles.ellipsisText}
        onMouseEnter={(e) => handlePopoverOpen(e, row[col.field])}
        onMouseLeave={() => handlePopoverClose()}
        style={{ textAlign: col.alignment || "left" }}
      >
        {/* Show '-' if value is empty, else show value */}
        {row[col.field] === null || row[col.field] === undefined || row[col.field] === '' ? 'N/A' : row[col.field]}
      </div>
    );

  return (
    <div
      className={clsx(
        styles.tableRow,
        row.isSelected && styles.defaultSelectedRow,
        classNames.tableRowClassName instanceof Function
          ? classNames.tableRowClassName(row, snapshot?.isDragging)
          : classNames.tableRowClassName
      )}
      style={{
        ...style,
      }}
    >
      {columns?.map((col) => (
        <div
          className={clsx(styles.tableCell, classNames.tableCellClassName)}
          style={{
            height: "100%",
            ...col.style,
            ...col.cellStyles,
            display: "inline-flex",
            alignItems: "center",
            width: col.width,
            justifyContent: getFlexAlignment(col.alignment),
          }}
          key={`${row.asn}-${col.field}`}
        >
          {renderColumnCell(col)}
        </div>
      ))}
    </div>
  );
};

TableRow.propTypes = {
  classNames: PropTypes.shape({
    tableContainerClassName: PropTypes.string,
    tableClassName: PropTypes.string,
    tableRowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    tableHeadClassName: PropTypes.string,
    tableCellClassName: PropTypes.string,
  }),
  columns: columnsPropType,
  index: PropTypes.number,
  row: PropTypes.shape({
    asn: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
  }).isRequired,
  style: PropTypes.object,
  snapshot: PropTypes.object,
  handlePopoverOpen: PropTypes.func.isRequired,
  handlePopoverClose: PropTypes.func.isRequired,
  onCopy: PropTypes.func.isRequired,
};

export default TableRow;
